import { validatable } from '../mixins/validation'
import { observable, computed } from 'mobx'
import { serializable, serialize, snapshotable } from '../data/serialization'
import { receiveErrors } from '../data/serverErrors'
import { Types } from '../data/Type'
import RynoEditor from '../ryno-editor/RynoEditor'
import { func } from 'validx'

/**
 * Personal tax organizer config editor.
 */
@snapshotable
@validatable({ liveValidation: true })
export default class PersonalOrganizerConfigEditor {
  @observable
  @serializable
  enabled_expr

  /**
   * The organizer only applies to tax legends, so the formula is only
   * validated for those.
   */
  @computed
  get rules() {
    if (this.legendEditor.isTaxLegend) {
      return {
        enabled_expr: [
          func((ctx) => ctx.value.analyze(), 'There are formula errors.'),
        ],
      }
    } else {
      return {
        enabled_expr: [],
      }
    }
  }

  constructor(legendEditor) {
    this.legendEditor = legendEditor
    this.enabled_expr = new RynoEditor({
      getSymbolTable: () => this.symbolTable,
      getNeededType: () => Types.boolean,
    })
  }

  @computed
  get symbolTable() {
    return this.legendEditor.getSymbolTableFor(this)
  }

  hydrate(personalOrganizerConfig) {
    if (!personalOrganizerConfig) {
      this.enabled_expr.setValue('')
      return
    }

    this.enabled_expr.setValue(personalOrganizerConfig.enabled_expr, true)
  }

  toJSON() {
    return serialize(this)
  }

  receiveErrors(descriptor = {}) {
    const { inner = {} } = descriptor
    receiveErrors(this, inner)
  }
}
